import RestService from "./rest.service";

class SecurityService {
  listUser() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/security/users`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listUserRole(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/security/users?role=` + serial).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listRolePermission() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/security/role`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  detailRolePermission(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/security/role/` + data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listTargetGroup() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/target_group?status=active`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getRoleForm() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/security/role/form`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  addRolePermission(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/security/role/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editRolePermission(data, serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/security/role/${serial}/edit`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteRolePermission(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/security/role/${serial}/delete`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  detailUser(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/security/users/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listRolePermissionUser() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/security/role?type=manual&status=active`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editUser(data, serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/security/users/${serial}`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  resetPasswordRandom(data, serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.postsReset(`app/admin/kpi/security/users/${serial}/resetPassword`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  resetPasswordInEmai(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.postsReset(`app/admin/kpi/security/users/${serial}/sendResetPassword`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  randomPassword() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/randomPassword`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new SecurityService();
